
import { useState, useEffect, useRef } from 'react';

const useGetPosition = () => {
    const [position, setPosition] = useState({ y: 0, x: 0 });
    const divRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const updatePosition = () => {
            if (divRef.current) {
                const rect = divRef.current.getBoundingClientRect();
                setPosition({ y: rect.y, x: rect.x });
            }
        };
        updatePosition();
        window.addEventListener('resize', updatePosition);
        return () => {
            window.removeEventListener('resize', updatePosition);
        };
    }, []);

    return { position, divRef };
};


export default useGetPosition